import { ISVG } from "../UrlIcon";

export const VerticalMiddleIcon = ({ className }: ISVG) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            viewBox="0 0 145.066 163.199"
            className={`${className || ""}`}
        >
            <path d="m72.534 99.733-27.2 27.2h18.133V163.2h18.134v-36.267h18.133Zm27.2-63.466H81.601V0H63.467v36.267H45.334l27.2 27.2ZM145.067 81.6c0-5.015-.436-9.067-5.44-9.067H5.441c-5 0-5.44 4.052-5.44 9.067 0 5 .436 9.067 5.44 9.067h134.186c5.004-.001 5.44-4.067 5.44-9.067Z" />
        </svg>
    );
};
